import { deepmerge, objectToArray, getProp } from '../libs/utils'

const globalSchemas = {}
const DATABASE = '__DATABASE_NAME__'

const reqs = [
  {
    req: require.context('@yellow-capital/tp-database/collections/', true, /schema\.js$/),
    database: DATABASE,
  },
  // hiding arbitrage database
  // {
  //   req: require.context('@yellow-capital/tp-database/arbitrage-collections/', true, /schema\.js$/),
  //   database: 'ARBITRAGE',
  // },
]

const hideCollections = [
  'app-configs',
  'bot-actual-rates',
  'bot-group-states',
  'convertor-configs',
  'equalizer-configs',
  'historical-sales-bitstamp-to-clients',
  'historical-sales-clients-to-daily',
  'historical-deposits-withdraws-config',
  'historical-executions-monitoring-charts-weekly',
  'historical-executions-monitoring-charts',
  'historical-order-executions',
  'historical-trade-configs',
  'historical-volume-configs',
  'historical-trade-states',
  'historical-sales-exchange-to-tpw',
  'notification-email-configs',
  'sale-account-groups',
  'sale-automate-configs',
  'sale-client-configs',
  'sale-configs',
  'sale-mm-sale-report-configs',
  'spreadsheet-token-configs',
  'virtual-account-orders',
  'virtual-balances'
]

for (const { req, database } of reqs) {
  req.keys().forEach((filename, index, allFiles) => {
    try {
      const filenameRelativePath = filename.slice(2)
      const filePathWithoutExtension = (() => {
        const tmpStack = filenameRelativePath.split('.')
        tmpStack.pop()
        return tmpStack.join('.')
      })()
      const isUnderDirectory = filenameRelativePath.split('/').length >= 2
      if (isUnderDirectory) {
        const [ collection ] = filePathWithoutExtension.split('/')
        if (!hideCollections.includes(collection.toLowerCase())) {
          globalSchemas[database] = globalSchemas[database] || {}
          globalSchemas[database][collection] = req(filename)
          globalSchemas[database][collection].schema = typeof (globalSchemas[database][collection].schema) === 'function' ? globalSchemas[database][collection].schema() : globalSchemas[database][collection].schema
          globalSchemas[database][collection] = prepareData(globalSchemas[database][collection])
        }
      }
    } catch (e) {
      console.log('Schema Error!', filename)
      console.error(e)
    }
  })
}

function prepareData (schemaConfig) {
  let { schema = {} } = schemaConfig
  const discriminators = getSchemaDiscriminatorValue(schemaConfig)
  const discriminatorKey = getSchemaDiscriminatorKey(schemaConfig)
  if (discriminators && discriminatorKey) {
    const discriminatorKeys = Object.keys(discriminators)
    const schemaProp = { ...schema[discriminatorKey] }
    schemaProp['enum'] = discriminatorKeys
    schema = { ...schema, [discriminatorKey]: schemaProp }
  }
  return { ...schemaConfig, schema }
}

export const schemas = globalSchemas

export const getSchemaConfig = (database, collection) => {
  database = database || DATABASE
  if (globalSchemas[database] && globalSchemas[database][collection]) {
    const schemaConfig = globalSchemas[database][collection]
    return schemaConfig
  }
  return null
}

export const getConnectorSchemaConfig = (database, collection) => {
  const schemaConfig = getSchemaConfig(database, collection)
  if (schemaConfig) {
    return { database, collection, schema: schemaConfig }
  }
  return null
}

export const getDefaultConnectorSchema = (database, collection) => {
  const schemaConfig = getSchemaConfig(database, collection)
  if (schemaConfig) {
    return { database, collection, schema: schemaConfig.schema }
  }
  return null
}

export const getSchemaDiscriminatorList = (database, collection) => {
  const schemaConfig = getSchemaConfig(database, collection)
  if (schemaConfig) {
    const { schema = {}, discriminators = {} } = schemaConfig
    return objectToArray(discriminators).map(obj => {
      const mergedSchema = deepmerge(schema, obj.value)
      return { ...obj, value: mergedSchema }
    })
  }
  return null
}

export const schemaGenerator = (model = {}, schema = {}, discriminators, discriminatorKey) => {
  if (discriminators && discriminatorKey) {
    const discriminatorTargetKey = model[discriminatorKey]
    const discriminatorTarget = discriminators[discriminatorTargetKey]
    if (discriminatorTarget) {
      const mergedSchema = deepmerge(schema, discriminatorTarget)
      return mergedSchema
    }
  }
  return schema
}

export function getSchemaDiscriminatorValue (schemaConfig) {
  return getProp(schemaConfig, 'discriminators')
}

export function getSchemaDiscriminatorKey (schemaConfig) {
  return getProp(schemaConfig, 'options.discriminatorKey')
}
